import React, { useState, useEffect } from "react";
import "./patientFeedback.css"; 
import curebayLogo from '../../assets/images/loginLogo.svg'; 
import apiService from "../../services/apiservice";

const ratings = [
  { value: 1, label: "VERY BAD", color: "#f65c5c" },
  { value: 2, label: "POOR", color: "#f7a928" },
  { value: 3, label: "AVERAGE", color: "#f5d022" },
  { value: 4, label: "GOOD", color: "#3cc7c1" },
  { value: 5, label: "EXCELLENT", color: "#42d17a" },
];

const PatientFeedback = () => {
  const [selectedRating, setSelectedRating] = useState(null);
  const [comments, setComments] = useState("");
  const [loading, setLoading] = useState(false);
  const [feedbackId, setFeedbackId] = useState(null);
  const [patientName, setPatientName] = useState("");
  const [message, setMessage] = useState({ type: "", text: "" });

  useEffect(() => {
    const queryParams = new URLSearchParams(globalThis.location.search);
    const id = queryParams.get('Id');
    const patient = queryParams.get('patientName');
    
    setFeedbackId(id);
    setPatientName(patient || "");
  }, []);

  const handleSubmit = async () => {
    setMessage({ type: "", text: "" });

    if (!selectedRating) {
      setMessage({ 
        type: "error", 
        text: "Please select a rating" 
      });
      return;
    }

    if (!feedbackId) {
      setMessage({ 
        type: "error", 
        text: "Feedback ID is missing" 
      });
      return;
    }

    
    const payload = {
      feedbackRate: selectedRating.toString(),
      feedbackNote: comments.trim(),
      feedbackId: feedbackId,
    };

    try {
      setLoading(true);
      const response = await apiService.feedbackSubmit(payload);
      
      if (response?.data.responseCode === "200") {
        setMessage({ 
          type: "success", 
          text: "Feedback submitted successfully!" 
        });
        
        setSelectedRating(null);
        setComments("");
        
        setTimeout(() => {
          setMessage({ type: "", text: "" });
        }, 5000);
      } else {
        setMessage({ 
          type: "error", 
          text: response?.responseMessage || "Submission failed. Please try again." 
        });
      }
    } catch (err) {
      setMessage({ 
        type: "error", 
        text: err?.response?.data?.responseMessage || "Submission failed. Please try again." 
      });
      console.error("Feedback submission error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleRatingKeyDown = (e, value) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setSelectedRating(value);
    }
  };

  return (
    <div className="feedback-container">
      <div className="logo-wrapper">
        <img
          src={curebayLogo}
          alt="Curebay Logo"
          className="curebay-logo"
        />
      </div>

      <h2 className="feedback-title">
        Rate Your Surgery Experience at {"Curebay"}
      </h2>
      
      {patientName && (
        <p className="patient-name">Patient: {decodeURIComponent(patientName)}</p>
      )}

      {message.text && (
        <div className={`message-container ${message.type}`}>
          <div className="message-content">
            {message.type === "success" ? (
              <svg className="message-icon" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            ) : (
              <svg className="message-icon" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
            )}
            <span className="message-text">{message.text}</span>
          </div>
        </div>
      )}

      <div className="rating-bar mt-10">
        {ratings.map((item) => (
    <button
            key={item.value}
            type="button"
            className={`rating-segment ${
              selectedRating === item.value ? "selected" : ""
            }`}
            style={{
              backgroundColor: item.color,
              opacity: selectedRating && selectedRating !== item.value ? 0.4 : 1,
            }}
            onClick={() => setSelectedRating(item.value)}
            onKeyDown={(e) => handleRatingKeyDown(e, item.value)}
            aria-label={`Rate as ${item.label}`}
          >
            <span className="rating-number">{item.value}</span>
            <span className="rating-label">{item.label}</span>
          </button>
        ))}
      </div>

      <textarea
        className="feedback-textarea"
        placeholder="Tell us more about your experience..."
        value={comments}
        onChange={(e) => setComments(e.target.value)}
      />

      <button
        className="submit-btn"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? "Submitting..." : "Submit Feedback"}
      </button>
    </div>
  );
};

export default PatientFeedback;